<template>
  <div>
    <v-app style="height: 10px;">
      <v-progress-linear v-show="loading" indeterminate></v-progress-linear>
    </v-app>
    <div v-if="orderId !== ''">
      <div ref="wrapper" id="wrapper" class="payment_wrapper page-break" v-for="payment in paymentList" :key="payment.no">
        <div class="top">
          <div class="post">
            <div class="box">國&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;內<br/>郵&nbsp;&nbsp;資&nbsp;&nbsp;已&nbsp;&nbsp;付<br/></div>
            ◯◯郵局許可證<br/>
            ◯◯字第◯◯號
          </div>
          <div class="address">
            <div class="com">
              嘉好企業有限公司<br/>
              Chia-Hao Enterprise Co., Ltd.
            </div>
            高雄市三民區九如一路994號<br/>
            客服專線：07-9564786
          </div>
          <div class="name"><span>{{itemDetail.name}}</span>鈞啟</div>
          <div class="nb">繳款人代號：{{'--'}}</div>
          <div class="ps">繳費說明：請多利用下列銀行繳款免收手續費；如至郵局、7-11、全家、萊爾富、OK 繳款，<br/>便利商店單筆上限 2 萬元，郵局繳款益需自付郵局郵局手續費。</div>
          <div class="notice">繳款專用通知函</div>

        </div><!--top-->
        <div>
          <div class="center">
            <div class="tit">
              <span>嘉好企業有限公司&nbsp;&nbsp;&nbsp;&nbsp;繳費收據</span><br/>
              主辦行：國泰世華商業銀行&nbsp
            </div>
            <div class="rPs1">第一聯：繳費明細聯</div>
            <table class="table1">
              <tr>
                <th rowspan="8" width="25px">收<br/>費<br/>項<br/>目</th>
                <td width="115px">本期金額</td>
                <td width="110px" class="txtR">${{payment.price}}</td>
                <td rowspan="8" width="265px" class="note">
                  <h4>注意事項</h4>
                  <p>本期期數：{{payment.no}}<br/>剩餘繳款期數：{{paymentList.length - payment.no}}<br/>總繳款期數：{{paymentList.length}}<br/>繳費方式</p>
                  <ul>
                    <li>1.全省【國泰世華銀行】臨櫃繳交或利用自動<br/>&nbsp;&nbsp;&nbsp;化設備轉帳(輸入銀行代號「013」(國泰世華銀行))再輸入繳款帳號及繳款金額。<br/>※請多利用各銀行提款機轉帳繳款。</li>
                    <li>2.本單據若有以下情形，請勿至超商繳納：<br/>&nbsp;&nbsp;&nbsp;(1)更改單據內容 (2)無超商代收條碼</li>
                  </ul>
                  <p>※為保障您的權益，請記得索取超商繳費證明單及核對金額，並同時保留單據，以利查詢。</p>

                </td>
                <th colspan="2">嘉好企業有限公司</th>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <th colspan="2">{{customProductName}}</th>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td width="130px" class="txtR">姓名：</td>
                <td>{{itemDetail.name}}</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td class="txtR">本期期數：</td>
                <td>第{{payment.no}}期</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td class="txtR">總期數：</td>
                <td>{{paymentList.length}}</td>
              </tr>
              <tr>
                <td colspan="2"></td>
                <td class="txtR">繳款日期：</td>
                <td>{{payment.paymentDate}}</td>
              </tr>
              <tr>
                <td rowspan="2" class="txtC">應繳金額</td>
                <td rowspan="2" class="txtC">${{payment.price}}</td>
                <td class="txtR fwB">繳款金額：</td>
                <td class="fwB">${{payment.price}}</td>
              </tr>
              <tr>
                <td colspan="2" class="seal">
                  <span class="titS">收<br/>款<br/>戳<br/>記</span>
                  <span class="circle"></span>
                </td>
              </tr>
            </table>
          </div><!--center-->
          <div class="bottom">
            <div class="rPs2">第二聯：收款單位傳票聯</div>
            <div class="sealBox">
              收訖戳記
              <span class="circle"></span>
            </div>
            <table class="table2">
              <tr>
                <th width="75px">戶&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</th>
                <!--上勇實業社呂淑雲 / 嘉好企業有限公司-->
                <td width="270px">嘉好企業有限公司</td>
                <th width="100px">臨櫃繳款帳號</th>
                <td class="txtC">{{payment.virtualAccount}}</td>
              </tr>
            </table>
            <table class="table3">
              <tr>
                <th width="75px">繳款人資料</th>
                <td>
                  <div class="detail">
                    姓名：{{itemDetail.name}}<br/>
                    繳款人代號：<br/>
                    <div class="fz">
                      <!--AO：{{getSalesName}}<span class="store">{{getVendorName}}</span>-->
                      AO：
                    </div>
                  </div>
                  <div class="date">
                    <span class="dateTit">繳款日期</span><br/>
                    {{payment.paymentDate}}<br/>
                    <span class="fz"></span><br/>
                  </div>
                </td>
                <td rowspan="4" class="code" width="245px">
                  <h4>便利商店專用條碼區</h4>
                  <p>全省超商門市(7-11、全家、萊爾富、OK)<br/>可代收費用。</p>
                  <div class="codeBox1">
                    <svg :id="`barcode1_${payment.no}`"></svg>
                  </div>
                  <div class="codeBox2">
                    <svg :id="`barcode2_${payment.no}`"></svg>
                  </div>
                  <div class="codeBox3">
                    <svg :id="`barcode3_${payment.no}`"></svg>
                  </div>
                </td>
              </tr>
              <tr class="mon">
                <th>繳費金額</th>
                <td>${{payment.price}}<span>〔金額塗改請勿收單〕</span></td>
              </tr>
              <tr>
                <td colspan="2" class="ps3">※國泰世華銀行請以「1010/0045/1045/51073」交易入帳,帳號欄位直接以虛擬帳號鍵入。</td>
              </tr>
              <tr class="trCode">
                <td>銀行臨櫃</td>
                <td>
                  <div class="codeBox4">
                    <svg :id="`barcode4_${payment.no}`"></svg>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="3">認證欄</td>
              </tr>
              <tr class="sts">
                <td colspan="3">經副襄理&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;會計&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;營業&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;出納&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;記帳</td>
              </tr>
            </table>

          </div><!--botton-->
          <div class="footer">嘉好企業有限公司客服專線：07-9564786</div>
        </div>
      </div><!--wrapper-->
    </div>

  </div>
</template>

<script>
import JsBarcode from 'jsbarcode';
import { getCurrentDate, addMonth } from '@/pages/utils/tool';
import { mapActions } from 'vuex';

export default {
  name: 'MarketPaymentView',
  data(){
    return {
      itemDetail: {
        name: '',
        period: 1,
        total: 0,
      },
      paymentList : [],
      loading:false,
      virtualAccount:'',
      startDate:'',
      endDate:'',
      beforeCount:false,
      productName:'',
      comment:'',
      orderId: '',
    };
  },
  created() {
    const query = this.$route.query;
    console.log(`query =${JSON.stringify(query)}`);
    if (query.orderId && query.orderId !== ''){
      this.orderId = query.orderId;
      this.loadPaymentData(query.orderId);
    }

  },
  computed: {
    currentDate() {
      return getCurrentDate();
    },
    customProductName(){
      if(this.productName === ''){
        return '嘉好通代收代付費用'
      }
      return this.productName;
    },
  },
  methods: {
    ...mapActions(['getMarketPaymentInfo' ]),
    async loadPaymentData(orderId){
      this.loading = true;
      const res = await this.getMarketPaymentInfo({ orderId });
      const result = res.data;
      this.loading = false;
      console.log(`loadPaymentData == ${JSON.stringify(result)}`);
      if (result.statusCode === 0){
        const order = result.data;
        this.productName = order.productName;
        this.itemDetail.name = order.name;
        this.itemDetail.total = order.total;
        this.itemDetail.period = order.period;
        this.paymentList = order.paymentList;
        for (let item of this.paymentList){
          this.createBarCode(item.barCode1, item.barCode2, item.barCode3, item.barCode4 , item.no);
        }
      } else {
        alert(result.message);
      }
    },
    createBarCode(barCode1, barCode2, barCode3, barCode4 , i){
      const formatCode = {
        format: "CODE39",
        fontSize:30,
      };
      setTimeout(()=>{
        JsBarcode(`#barcode1_${i}`, barCode1 , formatCode);
      } , 500);

      setTimeout(()=>{
        JsBarcode(`#barcode2_${i}`, barCode2, formatCode);
      } , 500);

      setTimeout(()=>{
        JsBarcode(`#barcode3_${i}`, barCode3, formatCode);
      } , 500);

      setTimeout(()=>{
        JsBarcode(`#barcode4_${i}`, barCode4, formatCode);
      } , 500);
    },
  }
};
</script>

<style scoped src="../../assets/css/market_payment_view.css">

</style>

<style>
.page-break{
  display: block;
  page-break-after: always;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/web/MarketPaymentView.vue